import { getAuthData } from '../../helpers/localStorageHelpers';
import { Api, HttpResponse } from './apiSchema';
import { http } from './http';
// import i18n from "i18next";

const customFetch = async (
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> => {
  const authToken = getAuthData()?.access_token;

  // let currentLocale = i18n.language;

  const headers = {
    ...init?.headers,
    Authorization: authToken ? `Bearer ${authToken}` : null,
    // "Accept-Language": currentLocale,
  };

  const response = await http(input, {
    ...init,
    headers: headers,
  } as RequestInit);
  return response;
};

export const ENV_WEB_API_BASEPATH =
  process.env.REACT_APP_API_BASE_URL || 'https://api.womapp.uk';

export const api = new Api({ baseUrl: ENV_WEB_API_BASEPATH, customFetch });

// Helper for making API requests
export const apiHelper = {
  get: async <T>(url: string) => {
    const response = await customFetch(`${ENV_WEB_API_BASEPATH}${url}`, {
      method: 'GET',
    });
    const data = await response.json();
    return { data: data as T };
  },
  post: async <T>(url: string, body?: any) => {
    const response = await customFetch(`${ENV_WEB_API_BASEPATH}${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    return { data: data as T };
  },
};

// TODO: Replace any with error view model
export const useApi = async <T>(
  request: () => Promise<HttpResponse<T, any>>
) => {
  let isLoading = false;
  let result = null;
  let error = null;

  // TODO: Replace any with error view model
  let response: HttpResponse<T, any>;
  try {
    isLoading = true;
    response = await request();
    result = response.data;
    isLoading = false;
  } catch (err: any) {
    console.error('Error happened during web api request: ', err.error);
    console.log('HTTP Response code, ', err.status);
    error = err.error;
  }

  return {
    isLoading: isLoading,
    result: result,
    error: error,
  };
};
